/**
 * @returns True if we're running in Internet Explorer, otherwise false.
 */
export function isRunningInInternetExplorer() {
    // Based on https://stackoverflow.com/a/24861307

    return navigator.appName === 'Microsoft Internet Explorer' ||
        !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/));
}